import { VincularFuncoesGrupoInterface } from "../../../Interfaces/Geral/Grupos/GruposFuncaoInterface";

import {
    DesvincularFuncaoGrupoService,
    VincularFuncoesGrupoService,
    ListarFuncoesVinculadasPorGrupoService,
    ListarFuncoesVinculadasPorGrupoeSistemaService,
    ListarFuncoesNaoVinculadasPorGrupoService,
    ListarFuncoesNaoVinculadosPorGrupoeSistemaService,
} from "../../../Services/Geral/Grupos/GruposFuncaoService";

import { Controller } from "../../Controller";

export async function DesvincularFuncaoGrupoController(
    IDFuncaoGrupo: number[]
) {
    return Controller(DesvincularFuncaoGrupoService(IDFuncaoGrupo));
}

export async function VincularFuncoesGrupoController(
    requestBody: VincularFuncoesGrupoInterface[]
) {
    return Controller(VincularFuncoesGrupoService(requestBody));
}

export async function ListarFuncoesVinculadasPorGrupoController(
    IDGrupo: number
) {
    return Controller(ListarFuncoesVinculadasPorGrupoService(IDGrupo));
}

export async function ListarFuncoesVinculadasPorGrupoeSistemaController(
    IDGrupo: number,
    IDSistema: number
) {
    return Controller(
        ListarFuncoesVinculadasPorGrupoeSistemaService(IDGrupo, IDSistema)
    );
}

export async function ListarFuncoesNaoVinculadasPorGrupoController(
    IDGrupo: number
) {
    return Controller(ListarFuncoesNaoVinculadasPorGrupoService(IDGrupo));
}

export async function ListarFuncoesNaoVinculadosPorGrupoeSistemaController(
    IDGrupo: number,
    IDSistema: number
) {
    return Controller(
        ListarFuncoesNaoVinculadosPorGrupoeSistemaService(IDGrupo, IDSistema)
    );
}
